import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AdminService } from '../../../../openapi/build';
import { ReleaseNotes } from '../models/release-notes.model';
import { map, catchError } from 'rxjs/operators';
import { ReleaseNotesMapper } from '../models/release-notes-mapper';

@Injectable({
  providedIn: 'root'
})
export class ReleaseNotesService {
  private readonly STORAGE_KEY = 'hermes_app_version';

  constructor(private readonly adminService: AdminService) {}

  obtenirVersionActuelle(): string {
    return environment.numVersionApp;
  }

  obtenirDerniereVersionVue(): string | null {
    return localStorage.getItem(this.STORAGE_KEY);
  }

  enregistrerVersionActuelle(): void {
    localStorage.setItem(this.STORAGE_KEY, this.obtenirVersionActuelle());
  }

  aVuVersionActuelle(): boolean {
    return this.obtenirDerniereVersionVue() === this.obtenirVersionActuelle();
  }

  obtenirHistoriqueNotesVersion(): Observable<ReleaseNotes[]> {
    return this.adminService.getAdminReleaseNotes().pipe(map(list => list.map(ReleaseNotesMapper.fromApiOutput)));
  }

  ajouterNoteVersion(releaseNotes: ReleaseNotes): Observable<ReleaseNotes> {
    const noteAvecDate = {
      ...releaseNotes,
      date: releaseNotes.date || new Date().toISOString()
    };
    return this.adminService
      .postPostAdminReleaseNote(ReleaseNotesMapper.toApiInput(noteAvecDate))
      .pipe(map(ReleaseNotesMapper.fromApiOutput));
  }

  modifierNoteVersion(uuid: string, releaseNotes: ReleaseNotes): Observable<ReleaseNotes> {
    return this.adminService
      .putPutAdminReleaseNote(uuid, ReleaseNotesMapper.toApiInput(releaseNotes))
      .pipe(map(ReleaseNotesMapper.fromApiOutput));
  }

  obtenirNotesVersion(version: string): Observable<ReleaseNotes> {
    return this.adminService.getGetAdminReleaseNote(version).pipe(map(releaseNotes => ReleaseNotesMapper.fromApiOutput(releaseNotes)));
  }

  supprimerVersion(uuid: string): Observable<void> {
    return this.adminService.deleteDeleteAdminReleaseNote(uuid).pipe(
      catchError(error => {
        return throwError(() => error.error.message);
      })
    );
  }
}
